import axios from "axios";
import { env as environment } from "../environments";

export const getS3PdfFilename = (sessionId) =>
  sessionId + "-" + "upload" + ".pdf";

export function appendS3FilenameArrayPart(formData, filenames) {
  formData.append("s3filename", JSON.stringify(filenames));
}

/** `["{sessionId}-upload.pdf", …]` — one entry per file (names align with s3uploadCapture `filename`). */
export function appendS3FilenameArrayPartForSession(formData, sessionId, fileCount) {
  const names = Array.from({ length: fileCount }, () => getS3PdfFilename(sessionId));
  appendS3FilenameArrayPart(formData, names);
}

export const s3fileHandler = async (file, sessionId, type) => {
  try {
    const formData = new FormData();
    if (type === "image") {
      formData.append("filename", sessionId + "-" + "upload" + "-" + "image");
      formData.append("file", file, sessionId + "-" + "upload" + "-" + "image");
    } else {
      const pdfName = getS3PdfFilename(sessionId);
      formData.append("filename", pdfName);
      formData.append("file", file, pdfName);
    }

    await axios.post(environment.s3Upload, formData);
  } catch (err) {
    console.error(`Error in s3File upload`, err.message);
    throw err;
  }
};
